import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ProGalleryHoverItem } from '../index';
import { ReactComponent as PlayIcon } from '../../../../../../assets/thumbnailes/play.svg';
import { ReactComponent as CollectionIcon } from '../../../../../../assets/thumbnailes/collection.svg';
import { ReactComponent as ShoppingIcon } from '../../../../../../assets/thumbnailes/shopping.svg';
import { ReactComponent as LinkIcon } from '../../../../../../assets/thumbnailes/link.svg';
import { CLICKING_ON_ITEM_OPTIONS } from '../../../../../constants/settingsConstants';
import triggerEvent from '../../../../../actions/services/biSiteLogger';
import biData from '../../../../../bi/feedEvents.json';
import { st, classes } from './ProGalleryInfoItem.st.css';

const isDisplayIconCart = (mediaLinksMap, mediaId) => {
  return (
    mediaLinksMap &&
    mediaLinksMap.has(mediaId) &&
    mediaLinksMap.get(mediaId).hasLinks &&
    mediaLinksMap.get(mediaId).isProduct === true
  );
};

const isDisplayIconLink = (mediaLinksMap, mediaId) => {
  return (
    mediaLinksMap &&
    mediaLinksMap.has(mediaId) &&
    mediaLinksMap.get(mediaId).hasLinks &&
    mediaLinksMap.get(mediaId).isProduct === false &&
    mediaLinksMap.get(mediaId).isLink === true
  );
};

const ProGalleryInfoItem = ({
  mediaLinksMap,
  item,
  isHoverMode,
  isHoverPost,
  isMobile,
  clickingOnItem,
}) => {
  const [isHover, setIsHover] = useState(false);
  const isEditor = window.Wix.Utils.getViewMode() === 'editor';
  const isVideo = item.media_type === 'VIDEO';
  const isAlbum = item.media_type === 'CAROUSEL_ALBUM';
  const isCart = isDisplayIconCart(mediaLinksMap, item.id);
  const isLink = isDisplayIconLink(mediaLinksMap, item.id);
  const isWithIcon = isVideo || isAlbum || isCart || isLink;
  const isEnableClickOnItem =
    clickingOnItem !== CLICKING_ON_ITEM_OPTIONS.NOTHING_APPENED;

  return (
    <div
      className={st(classes.root, { isEnableClickOnItem })}
      onMouseEnter={() => {
        biData.HOVERING_OVER_UP.type = item.id;
        biData.HOVERING_OVER_UP.description = item.media_url;
        // biData.HOVERING_OVER_UP.gallery_type =
        if (isHoverPost) setIsHover(true);
      }}
      onMouseLeave={() => setIsHover(false)}
    >
      {isWithIcon ? (
        <div className={st(classes.bgIcon, { isMobile })}>
          <div className={st(classes.warpIcon, { isMobile })}>
            {isVideo ? (
              <PlayIcon />
            ) : isAlbum ? (
              <CollectionIcon />
            ) : isCart ? (
              <ShoppingIcon />
            ) : isLink ? (
              <LinkIcon />
            ) : null}
          </div>
        </div>
      ) : null}
      <ProGalleryHoverItem
        isHover={(isHover && !isEditor) || isHoverMode}
        item={item}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isHoverMode: state.settingsReducer.isHoverMode,
  isHoverPost: state.settingsReducer.isHoverPost,
  clickingOnItem: state.settingsReducer.clickingOnItem,
  isMobile: state.appReducer.isMobile,
});

export default connect(mapStateToProps, null)(ProGalleryInfoItem);
